import { Success, Fail, Loading, UnSet, ExtendedError } from 'store/types'
import { UnknownRecord } from 'types/global'

export const setFetchFail = (error: ExtendedError, requestId?: string) =>
  ({
    status: 'FAIL',
    error,
    requestId,
  } as Fail)

export const setSuccess = <D extends UnknownRecord>(data: D, requestId?: string) =>
  ({
    status: 'SUCCESS',
    data,
    requestId,
  } as Success<D>)

export const setLoading = (requestId?: string) =>
  ({
    status: 'LOADING',
    requestId,
  } as Loading)

export const unSet = () => ({ status: 'UN_SET' } as UnSet)
